function compareObject(obj1: object, obj2: object) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export function diff(obj1: object, obj2: object) {
  const isArray = Array.isArray(obj1);
  const result = isArray ? [] : {};

  if (compareObject(obj1, obj2)) {
    return undefined;
  }

  if (!obj2 || typeof obj2 !== 'object') {
    return obj2;
  }

  Object.keys(obj1 || {}).concat(Object.keys(obj2 || {})).forEach((key) => {
    if (obj2[key] !== obj1[key] && !compareObject(obj1[key], obj2[key])) {
      result[key] = obj2[key];
    }

    if (typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
      const value = diff(obj1[key], obj2[key]);
      if (value !== undefined) {
        result[key] = value;
      }
    }
  });

  return result;
}

export default diff;
